module.exports = __webpack_public_path__ + "media/application/images/couple-b1b81a62e560091b4a2306800dfaf574.png";